<template>
  <div class="cdwriserrelat">
    <sec-title
      Text="服务流程"
      desc-text="轻松五步立马获取量身定制的专业合同"
      class="text_center"
    />
    <div class="prodec flex_start">
      <div class="prodeitem prodeitem1">5-1分钟内律师来电</div>
      <div class="prodeitem prodeitem2">律师整理需求</div>
      <div class="prodeitem prodeitem3">1-2个工作日内完成</div>
      <div class="prodeitem prodeitem4">3日内免费答疑+不限次修改</div>
    </div>
    <div class="procont between">
      <div class="proctitem porbg1">
        <div class="proctitemti">下单付款</div>
        <div class="proctitemde">选择你需要的合同并下单</div>
      </div>
      <div class="jt">
        <img src="../../../assets/contmodeldet/zxjt.png" alt="" />
      </div>
      <div class="proctitem porbg2">
        <div class="proctitemti">一对一沟通需求</div>
        <div class="proctitemde">专业认证律师一对一沟通</div>
      </div>
      <div class="jt">
        <img src="../../../assets/contmodeldet/zxjt.png" alt="" />
      </div>
      <div class="proctitem porbg3">
        <div class="proctitemti">律师起草合同</div>
        <div class="proctitemde">根据沟通结果律师 开始撰写合同</div>
      </div>
      <div class="jt">
        <img src="../../../assets/contmodeldet/zxjt.png" alt="" />
      </div>
      <div class="proctitem porbg4">
        <div class="proctitemti">交付合同</div>
        <div class="proctitemde">撰写结束律师交付合同</div>
      </div>
      <div class="jt">
        <img src="../../../assets/contmodeldet/zxjt.png" alt="" />
      </div>
      <div class="proctitem porbg5">
        <div class="proctitemti">律师起草合同</div>
        <div class="proctitemde">根据沟通结果律师 开始撰写合同</div>
      </div>
    </div>

    <sec-title
      Text="服务和保障"
      desc-text="为您留心、省心，让您放心、安心"
      class="text_center mt50"
    />
    <div class="securitylist between wrap">
      <div class="securityitem flex_start">
        <div>
          <img src="../../../assets/contmodeldet/securicon1.png" alt="" />
        </div>
        <div> <div class="bt1">专业</div> <div class="bt2"> 甄选执业多年的资深律师，节省您宝贵的时间，为您省心 </div> </div>
      </div>     
      <div class="securityitem flex_start">
        <div>
          <img src="../../../assets/contmodeldet/securicon2.png" alt="" />
        </div>
        <div> <div class="bt1">快速</div> <div class="bt2">规范律师服务流程和响应时间，保证您优质的服务体验，让您放心 </div> </div>
      </div>
      <div class="securityitem flex_start">
        <div>
          <img src="../../../assets/contmodeldet/securicon3.png" alt="" />
        </div>
        <div> <div class="bt1">超值</div> <div class="bt2">全程监控服务，确保一次性缴纳所有费用后，无隐形收费，让您安心 </div> </div>
      </div>
      <div class="securityitem flex_start">
        <div>
          <img src="../../../assets/contmodeldet/securicon4.png" alt="" />
        </div>
        <div> <div class="bt1">优质</div> <div class="bt2"> 服务标准公开透明，有问题呼叫服务中心，争议快速解决，为您留心</div> </div>
      </div> 

    </div>
  </div>
</template>

<script>
import secTitle from "views/home/components/secTitle";
export default {
  components: {
    secTitle,
  },
};
</script>

<style lang="scss" scoped>
.cdwriserrelat {
  width: 1200px;
  padding: 50px 0 20px;
  margin: 0 auto;
  .prodec {
    .prodeitem {
      padding: 5px 9px;
      background: #f7f7f7;
      font-size: 16px;
      color: #666666;
      margin-left: 80px;
      &.prodeitem1 {
        margin-left: 134px;
      }
      &.prodeitem2 {
        margin-left: 120px;
      }
      &.prodeitem3 {
        margin-left: 126px;
      }
      &.prodeitem4 {
        margin-left: 80px;
      }
    }
  }
  .procont {
    margin-top: 5px;
    .jt {
      width: 66px;
      height: 8px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .proctitem {
      width: 168px;
      height: 168px;
      border-radius: 50%;
      text-align: center;
      padding: 38px 0;
      .proctitemti {
        font-size: 18px;
        color: #333333;
        font-weight: bold;
      }
      .proctitemde {
        padding: 0 20px;
        margin-top: 10px;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
      }
      &.porbg1 {
        background-color: #fbf0da;
        border: 10px solid #fffaf0;
      }

      &.porbg2 {
        background-color: #fbddda;
        border: 10px solid #fff0f0;
      }

      &.porbg3 {
        background-color: #dadafb;
        border: 10px solid #efefff;
      }

      &.porbg4 {
        background-color: #daedfb;
        border: 10px solid #eff8ff;
      }

      &.porbg5 {
        background-color: #d9fafb;
        border: 10px solid #eefeff;
      }
    }
  }
  .securitylist {
    .securityitem {
      width: 584px;
      height: 132px;
      margin-bottom: 30px;
      background: #ffffff;
      padding: 0 10px 0 29px;
      color: #333333;
      box-shadow: 0px 0px 10px 0px rgba(4, 0, 0, 0.05);
      img {
        margin-right: 13px;
      }
      .bt1 {
        font-size: 26px;
        line-height: 26px;
      }
      .bt2 {
        margin-top: 12px;
        font-size: 16px;
        color: #666666;
        line-height: 16px;
      }
    }
  }
}
</style>